import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LoadingShimmerModule } from 'loading-shimmer';
import { BaseComponent } from '../../../../models/base/base-component';

@Component({
  selector: 'app-data-label',
  templateUrl: './data-label.component.html',
  styleUrls: ['./data-label.component.scss'],
  standalone: true,
  imports: [NgIf, RouterLink, LoadingShimmerModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataLabelComponent extends BaseComponent {
  @Input() label: string = '--';
  @Input() value: string | number = '--';
  @Input() url: string = '';
  @Input() isLoading = false;

  setupViews(): void {}
  setupBindings(): void {}
}
